// 全站搜索
import { fetch } from '../request';
import type { IPageResponse, IResponse } from '../interface';
import type {
  ISiteSearchResult,
  RecommendSearchParams,
  RecommendSearchResult,
} from '../interface/search';

// 全站搜索热门搜索词
export const getSiteHotWord = (card_type: number, size?: number) => {
  return fetch<IResponse<string[]>>('/search/hot_search_keywords/', {
    params: {
      card_type,
      size,
    },
  });
};

// 全站搜索结果
export const getSiteSearchResult = (params: {
  category?: string;
  q: string;
  page: number;
  page_size: number;
}) => {
  return fetch<IPageResponse<ISiteSearchResult[]>>('/search/', {
    params,
  });
};

// 全站分词
export const getSiteSegmentWord = (q: string) => {
  return fetch<IResponse<string[]>>('/search/segment_word/', {
    params: { q },
  });
};

// 推荐搜索词
export const getRecommendSearchWords = (
  params: RecommendSearchParams,
  abortControl?: { signal: AbortSignal },
) =>
  fetch<IResponse<RecommendSearchResult[]>>('/search/recommend_questions/', {
    params,
    ...abortControl,
  });

// 3D数字人热词推荐
export const get3DHotWord = (_: number, size?: number) => {
  return fetch<IResponse<string[]>>('/material/editor_select_youyan_config/detail/', {
    params: {
      size,
      card_type: 1, // 0-换一换 1-热门推荐 2-banner位   由于服务平台只需要热词默认1
    },
  });
};
